const Iframe = (props: React.IframeHTMLAttributes<HTMLIFrameElement>) => {
  return <iframe {...props} />
}

export default Iframe
